jQuery(document).ready(function(){
 
   var $container = $('.main_masonry_container');
    
 
    
    $container.infinitescroll({
      navSelector  : '.pagination',    // selector for the paged navigation 
      nextSelector : '.pagination a.next',  // selector for the NEXT link (to page 2)
      itemSelector : '.all_masonry',     // selector for all items you'll retrieve
    loading: {
          finishedMsg: 'No more posts to load.',
          img: 'https://cdn.shopify.com/s/files/1/0674/3651/files/battery.gif?12180297032000253541'
        }
      },
      // trigger Masonry as a callback
      function( newElements ) {
        // hide new items while they are loading
        var $newElems = $( newElements ).css({ opacity: 0 });
        // ensure that images load before adding to masonry layout
        $newElems.imagesLoaded(function(){
          
          // show elems now they're ready
         // $newElems.animate({ opacity: 1 });
          //$container.masonry( 'appended', $newElems, true ); 
        
          jQuery($newElems).each(function(){
            if(jQuery(this).hasClass('masonry_item')){
           
               jQuery('#masonry_container1').append(jQuery(this).get(0).outerHTML);
            } else{
            jQuery('#masonry_container2').append(jQuery(this).get(0).outerHTML);
            }
            
          })
           jQuery('.all_masonry').animate({ opacity: 1 });
          jQuery($newElems).remove();
        });
      }
    );
    
  
  /*jQuery('.article_image').each(function(){
  
  
  }) */
})
    